<template>
  <div class="ptStarka">
    <menuBox :step="1"></menuBox>
    <div class="ptStarka-box">
      <div class="left">
        <div class="title">Abadikan keindahan dengan lensa Anda dan abadikan momen pada waktunya.</div>
        <div class="text">Bersama kami, setiap pengambilan gambar dibuat khusus untuk Anda. Baik itu film, video, atau
          acara TV, kami menjamin produksi paling profesional dan kreativitas tak terbatas untuk menjadikan cerita Anda
          puncak seni visual. Biarkan Anda menyimpan momen terbaik dan menjadi kenangan terbaik.
        </div>
      </div>
    </div>
    <div class="movies-box">
      <div class="title">Menonton film online</div>
      <div class="text">Yang baru akan datang</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home1.png" />
          <div class="fire">
            <p>Portrait of a Lady on Fire</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                4.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home2.png" />
          <div class="fire">
            <p>the lover</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" />
                3.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home3.png" />
          <div class="fire">
            <p>JOHN WICK 3</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                5.0
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home4.png" />
          <div class="fire">
            <p>Upgrade</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                3.5
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="our-box">
      <div class="left">
        <img src="../assets/home5.png" />
      </div>
      <div class="right">
        <div class="title">PT STARKA PRO INDONESIA</div>
        <div class="text">Gunakan film untuk merekam kehidupan dan membuat kenangan bertahan selamanya.</div>
        <div class="bt">Jelajahi kemungkinan tanpa batas, kami berkomitmen untuk memproduksi konten film dan televisi
          yang dipersonalisasi dan berkualitas tinggi untuk Anda. Biarkan ide Anda berubah menjadi gambar dan biarkan
          impian Anda bersinar di layar lebar.</div>
        <div class="list">
          <img src="../assets/home6.png" />
          <div>
            <p>teknologi maju</p>
            <span>Kami menggunakan teknologi dan peralatan produksi film dan televisi terkini, termasuk kamera resolusi
              tinggi, perangkat lunak pengeditan kelas profesional, dan alat efek visual canggih. Teknologi ini
              memastikan bahwa setiap karya yang kami hasilkan memenuhi standar industri terbaik.</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/home7.png" />
          <div>
            <p>Didorong oleh kreativitas</p>
            <span>Kreativitas adalah inti dari apa yang kami lakukan. Kami terus-menerus mengejar inovasi dan terobosan,
              memberikan vitalitas segar ke dalam setiap proyek dengan ide-ide baru dan ekspresi unik. Tujuan kami
              adalah menjadikan karya Anda unik baik secara visual maupun naratif.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top-box">
      <div class="title">Menonton film online</div>
      <div class="text">film dengan peringkat teratas</div>
      <div class="list-box">
        <div class="list">Televisi</div>
        <div class="list">Film</div>
        <div class="list">Dokumenter</div>
        <div class="list">Pendidikan Jasmani</div>
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home8.png" />
          <div class="fire">
            <p>Elsbeth</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                4.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home9.png" />
          <div class="fire">
            <p>Young Sheldon</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" />
                3.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home10.png" />
          <div class="fire">
            <p>The veil</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                5.0
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home11.png" />
          <div class="fire">
            <p>The regime</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                3.5
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="live-box">
      <div class="bt">Menonton daring</div>
      <div class="title">Tim profesional, karya cerdik, hanya untuk menyajikan karya terbaik. Saya harap Anda dapat
        menonton filmnya bersama keluarga dan teman-teman Anda dan bersenang-senang bersama!</div>
      <!-- <div class="text">Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod tempor.There are many
        variations of passages of lorem Ipsum available, but the majority have suffered alteration in some injected
        humour.</div> -->
      <div class="active">
        <div class="hd">HD</div>
        <div class="hd">4K</div>
        <div class="info">
          <p>20K+</p>
          <span>orang menonton film ini</span>
        </div>
      </div>
    </div>
    <div class="rated-box">
      <div class="title">Keahlian</div>
      <div class="text">film klasik
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home13.png" />
          <div class="fire">
            <p>House of the dragon</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                4.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home14.png" />
          <div class="fire">
            <p>Those about to die</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" />
                4.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home15.png" />
          <div class="fire">
            <p>海的开始</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">HD</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                4.5
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home16.png" />
          <div class="fire">
            <p>Inside NO.9</p>
            <span>2021</span>
          </div>
          <div class="hd">
            <div class="hd-b">4K</div>
            <div class="hd-min">
              <div class="time">
                <img src="../assets/time.png" class="logo" />
                128 min
              </div>
              <div class="time">
                <img src="../assets/xinxin.png" class="logo" />
                3.5
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "aboutUs" });
    }
  },
};
</script>

<style lang="less" scoped>
.ptStarka-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 312px;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  background-image: url(../assets/home.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  box-sizing: border-box;

  .left {
    width: 572px;

    .title {
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 24px;
      color: #E5D806;
      line-height: 33px;
    }

    .text {
      font-weight: 700;
      font-size: 30px;
      color: #FFFFFF;
    }
  }
}

.movies-box {
  padding: 100px 312px;
  background: #1E1D21;
  box-sizing: border-box;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.our-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 90px 312px;
  background: #121119;

  .left {
    img {
      margin-right: 96px;
      width: 510px;
      height: 546px;
    }
  }

  .right {
    .title {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 14px;
      color: #E5D806;
    }

    .text {
      margin-bottom: 24px;
      font-weight: 700;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
    }

    .bt {
      margin-bottom: 80px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 18px;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 65px;

      img {
        margin-right: 24px;
        width: 93px;
        height: 93px;
      }

      div {
        p {
          margin-bottom: 16px;
          font-weight: 700;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 28px;
        }

        span {
          font-size: 16px;
          color: #FFFFFF;
          line-height: 18px;
        }
      }
    }
  }
}

.top-box {
  padding: 100px 312px;
  background: #1E1D21;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
    text-align: center;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
  }

  .list-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 80px;

    .list {
      padding: 18px 20px;
      margin-right: 18px;
      background: #080B0D;
      border-radius: 8px;
      font-weight: 700;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 19px;
    }

    .list:nth-child(1) {
      color: #E5D806;
      border: 1px solid #E5D806;
    }
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.live-box {
  width: 100%;
  padding: 200px 312px;
  background-image: url(../assets/home12.png);
  width: 100%;
  height: 726px;
  background-size: 100% 100%;
  box-sizing: border-box;

  .bt {
    max-width: 650px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
  }

  .title {
    max-width: 650px;
    margin-bottom: 24px;
    font-size: 32px;
    color: #121119;
    line-height: 45px;
  }

  .text {
    max-width: 650px;
    margin-bottom: 40px;
    font-size: 16px;
    color: #121119;
    line-height: 18px;
  }

  .active {
    display: flex;
    align-items: center;

    .hd {
      margin-right: 20px;
      font-weight: 700;
      font-size: 60px;
      color: #FFFFFF;
      line-height: 85px;
      text-stroke: 1px #D81C2C;
      text-align: left;
      font-style: normal;
      -webkit-text-stroke: 1px #D81C2C;
    }

    .info {
      p {
        font-weight: 700;
        font-size: 32px;
        color: #121119;
        line-height: 45px;
      }

      span {
        font-weight: 700;
        font-size: 14px;
        color: #121119;
        line-height: 19px;
      }
    }
  }
}

.rated-box {
  padding: 100px 312px;
  background: #1E1D21;
  box-sizing: border-box;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
    text-align: center;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}
</style>
